/**
 * @desc Yung-审批前事件
 */
const URL = "/rantion-rms";
import http, { updateResponse } from "@/http";
export type Response = defs.rms.ResponseDto<ObjectMap>;
export function request(body: defs.rms.ApprovalBeforeRequestDto, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/rpc/approval/beforeEvent`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
